module.exports = __webpack_public_path__ + "img/1.de0e8e92.png";